export const SafetyCopilotHome = () => {
  return <div></div>;
};
